import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './Pages/Components/ErrorBoundary';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import {toast, ToastContainer} from "react-toastify";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_DEFAULT_PORT || 'http://127.0.0.1:8000';
axios.defaults.headers.get["Content-Type"] = 'application/json';
axios.defaults.headers.post["Content-Type"] = 'application/x-www-form-urlencoded';
axios.defaults.headers.accept = 'application/json';

axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    if(token && config.url !== 'auth/token')
        config.headers.Authorization = `Bearer ${token}`;

    return config;
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        let currentUrl = window.location.href
        let url = new URL(currentUrl);
        let formUrl = url.pathname
        let appendUrlStr = "";
        if(formUrl !== '/login') {
            appendUrlStr = "?returnUrl="+formUrl;
        } else if(formUrl === '/login') {
            
        } else {
            window.location.href = "/login"+appendUrlStr;
        }

    }
    return error;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
        <ToastContainer/>
    </BrowserRouter>
);

